import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {Provider} from 'react-redux'
import {createStore, applyMiddleware} from "redux";
import reducer from './reducers'
import * as serviceWorker from './serviceWorker';
import {Router} from "react-router-dom";
import { createStateSyncMiddleware, initStateWithPrevTab } from 'redux-state-sync'
import { history } from './constants/history';
const config = {}
const middlewares = [
  createStateSyncMiddleware(config),
]

//export const store = createStore(reducer);
export const store = createStore(reducer, {}, applyMiddleware(...middlewares))
initStateWithPrevTab(store)

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            <App/>
        </Router>
    </Provider>,
    document.getElementById("root")
)
;

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
